<template>
  <section class="edit-trial-form">
    <Breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-trial-form
        v-model="model"
        @submit="submit"
        @getUsers="getUsers"
        :disabled="true"
        :surgeonsPage="surgeonsPage"
        :questionnaires="questionnaires"
      />

      <rp-overlay :active="showOverlay">
        <rp-alert
          icon="done"
          message="The study has been updated"
          :onClick="closeOverlay" />
      </rp-overlay> 
    </div>

  </section>
</template>

<script>
import TrialForm from "raypro_ui/src/components/ui/forms/Trial"
import Breadcrumbs from "@/components/Breadcrumbs"
import Overlay from "raypro_ui/src/components/ui/Overlay"
import Alert from "raypro_ui/src/components/ui/Alert"
import page from "@/mixins/page"
import {getUsersByRoleAdmin} from 'raypro_ui/src/api/users'
import {getTrial, getTrialSurgeons, createTrialSurgeon} from 'raypro_ui/src/api/trials'
import {getQuestionnaires} from 'raypro_ui/src/api/questionnaire'

export default {
  mixins: [page],

  components: {
    "rp-trial-form": TrialForm,
    "rp-overlay": Overlay,
    "rp-alert": Alert,
    Breadcrumbs
  },

  data() {
    return {
      model: {},
      title: "Edit Study",
      breadcrumbs: [{ label: "Edit Study" }],
      surgeonsPage: {data: [], page: {page_size: 10, page_number: 1}},
      questionnaires: [],
      surgeons: [],
      showOverlay: false,
    };
  },

  computed: {
    trialId() {
      return this.$route.params.id
    }
  },

  async mounted() {
    await this.getTrial(this.trialId)
    await this.getTrialSurgeons(this.trialId)
    await this.getUsers(this.surgeonsPage.page)
  },

  methods: {
    async submit(trial) {
      trial.surgeon_enrolments.forEach(async (x) => {
        await createTrialSurgeon(this.trialId, {
          trial_surgeon: {
            surgeon_id: x.id,
            enrolment_target: x.enrolment_target
          }
        })
      })
      this.showOverlay = true
    },

    async getTrial(trialId) {
      let {data} = await getTrial(trialId)
      data.end_date = data.end_date.split("T")[0]
      this.questionnaires = data.questionnaires
      this.model = data
    },

    async getTrialSurgeons(trialId) {
      const {data} = await getTrialSurgeons(trialId)
      this.surgeons = data
    },

    async getUsers(pageData) {
      let {data, page} = await getUsersByRoleAdmin(pageData, "surgeon")
      this.surgeonsPage = {
        page,
        data: data.map((x) => {
          return {
            id: x.id,
            name: `${x.profile.first_name} ${x.profile.last_name}`,
            email: x.email,
            enrolment_target: (this.surgeons.find((y) => y.id === x.id))
              ? this.surgeons.find((y) => y.id === x.id).enrolment_target
              : 0
          }
        })
      }
    },

    async getQuestionnaires() {
      let {data} = await getQuestionnaires()
      this.questionnaires = data
    },

    closeOverlay() {
      this.showOverlay = false
      this.$router.push({name: 'view-study', params: {id: this.trialId}})
    },
  }
};
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/Clinical/EditTrial.vue